import React from 'react';

import Datepicker from '../Common/Datepicker.js';

export default class MissionEditTimeframe extends React.Component {
	constructor(props) {
		super(props);
	}

	getMonthFromName(monthName) {
		const months = {
		    'Jan' : 0,
		    'Feb' : 1,
		    'Mar' : 2,
		    'Apr' : 3,
		    'May' : 4,
		    'Jun' : 5,
		    'Jul' : 6,
		    'Aug' : 7,
		    'Sep' : 8,
		    'Oct' : 9,
		    'Nov' : 10,
		    'Dec' : 11
		}

		return months[monthName];
	}

	render() {
		const mission = this.props.mission;
		const missionType = this.props.missionType;
		const billingType = this.props.billingType;

		const missionHasLaunched = (typeof mission.launchDate === 'undefined' || !mission.launchDate) ? false : true;
		const launchDate = mission.launchDate;

		


		let startDate = mission.startDate;
		if (startDate == '') {
			// Set it to today's date.
			startDate = window.todayDate;
		}


		const startDateParts = startDate.split(' ');
		const endDateParts = mission.endDate.split(' ');
		let diffDays = 0;
		let endDateDirection = [];
		let billingMaxDuration = mission.billingMaxDuration;

		let weeksArray = [];
		let i = 1;

		let maxOngoingWeeks = Math.floor(billingMaxDuration/7);
		/*if (billingDurationTier == 180) {
			maxOngoingWeeks = 25;
		}
		else if (billingDurationTier == 90) {
			maxOngoingWeeks = 12;
		}*/

		while (i<=maxOngoingWeeks) {
			weeksArray.push(i);
			i++;
		}

		let i2 = 1;
		let recommendedWeeksArray = [];
		while (i2 <= (mission.maxTimeframe/7) ) {
			recommendedWeeksArray.push(i2);
			i2++;
		}

		if (startDate != '') {
			endDateDirection = [startDate,billingMaxDuration];

			if (mission.endDate != '') {	
				startDateParts[0] = startDateParts[0].match(/\d+/)[0];
				startDateParts[1] = this.getMonthFromName(startDateParts[1]);
				endDateParts[0] = endDateParts[0].match(/\d+/)[0];
				endDateParts[1] = this.getMonthFromName(endDateParts[1]);

				const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
				const secondDate = new Date(startDateParts[2], startDateParts[1], startDateParts[0]);
				const firstDate = new Date(endDateParts[2], endDateParts[1], endDateParts[0]);
				diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
			}
		}


		/*let newBillingDurationTier = mission.billingDurationTier;
		if (missionType == 'group') {
			if (mission.missionTimeframe == 'ongoing') {
				if (mission.maxTimeframe <= 90) {
					newBillingDurationTier = 90;
				}
				else if (mission.maxTimeframe <= 180) {
					newBillingDurationTier = 180;
				}
				else {
					newBillingDurationTier = 548;
				}
			}
			else {				
				if (diffDays <= 90) {
					newBillingDurationTier = 90;
				}
				else if (diffDays <= 180) {
					newBillingDurationTier = 180;
				}
				else {
					newBillingDurationTier = 548;
				}
			}
		}*/


		return (
			<React.Fragment>
				<h4 className="primary-color">MISSION TIMEFRAME</h4>

				<div>
				{(mission.missionTimeframe=='fixed') && (
					<div className="edit-mission-box">
						<label className="edit-mission-timeframe-radio">
							<div>
								<input type="radio" name="missionTimeframe" onChange={this.props.handleChange} value="fixed" checked={mission.missionTimeframe=='fixed' ? true : false} tabIndex="5" className="form-check-input" />
							</div>
							<div className="ms-3">
								<h3>Fixed duration</h3>
								<ul>
									<li>The mission will start and end on fixed dates for all participants</li>
									<li>You will need to manually launch the mission at the time you are ready to begin</li>
									<li>Your actual start and end dates will be determined by your launch and finish dates</li>
									{billingType == 'trial_demo' && (
										<li>You can set any duration however the trial mission will end automatically after 7 days</li>
									)}
								</ul>
							</div>
						</label>

						{mission.missionTimeframe == 'fixed' && (
							<div>
								<div className="edit-mission-timeframe-row">
									{false ? (
										<div className="col">
											<h3>Start Date</h3>
											<div className="edit-mission-fixed-timeframe">
												<p>{launchDate ? launchDate : 'Today'}</p>
											</div>
										</div>
									) : (
										<div className="col">
											<h3>Estimated Start Date</h3>
											<Datepicker updateDateValue={this.props.handleChangeDate} name={'startDate'} value={mission.startDate} placeholder="Pick a date" direction={[window.todayDate,730]} />
										</div>
									)}

									<div className="col">
										<h3>End Date</h3>
										<Datepicker updateDateValue={this.props.handleChangeDate} name={'endDate'} value={mission.endDate} placeholder="Pick a date" direction={endDateDirection} />
									</div>
									<div className="col">
										<h3>Duration</h3>
										<p className="mb-0 mt-2 primary-color weight-500">{diffDays} days</p>
										<p className="mb-0 tiny dark-grey">The max duration for this mission is {billingMaxDuration} days.</p>
									</div>
								</div>
								{(diffDays > billingMaxDuration) && (
									<p className="small danger mt-4">
										Your start and end dates are invalid because the maximum allowable timeframe for your group is {billingMaxDuration} days. Please change your start and end dates to fit within this duration, or contact us to extend your max timeframe.
									</p>
								)}
							</div>
						)}
					</div>
				)}

				{mission.missionTimeframe == 'ongoing' && missionType == 'group' && (
					<div className="edit-mission-box">
						<div>
							<label className="edit-mission-timeframe-radio">
								<div>
									<input type="radio" name="missionTimeframe" onChange={this.props.handleChange} value="ongoing" checked={mission.missionTimeframe=='ongoing' ? true : false} tabIndex="6" className="form-check-input" />
								</div>
								<div className="ms-3">
									<h3>On-going</h3>
									<ul>
										<li>Once the mission is live, unlike a fixed duration mission, the mission has no official "end date".</li>
										<li>Participants cannot post distances after the maximum timeframe or when you decide to end the mission.</li>
										<li>When a participant joins their timeframe defaults to the recommended timeframe.</li>
										<li>Each participant can choose their own timeframe up to your maximum timeframe.</li>
									</ul>
								</div>
							</label>

							{mission.missionTimeframe == 'ongoing' && (
								<div>
									<div className="row">
										<br />
										<div className="col">
											<h3>Recommended Timeframe</h3>
											<select name="defaultTimeframe" value={mission.defaultTimeframe} onChange={this.props.handleChange} className="form-select mt-2">
												{recommendedWeeksArray.map((item, index) => {
													if (item==52 && mission.maxTimeframe >= 365) {
														return (
															<React.Fragment key={item*7}>
																<option value={item*7} key={item}>{item} weeks</option>
																<option value="365" key="365">1 full year (365 days)</option>
															</React.Fragment>
														);
													}
													else if (item==78 && mission.maxTimeframe >= 548) {
														return (
															<React.Fragment key={item*7}>
																<option value={item*7} key={item}>{item} weeks</option>
																<option value="548" key="548">1.5 full years (548 days)</option>
															</React.Fragment>
														);
													}
													else {
														return <option value={item*7} key={item}>{item} weeks</option>
													}
												})}
											</select>
										</div>
										<div className="col">
											<h3>Max Timeframe</h3>
											<select name="maxTimeframe" value={mission.maxTimeframe} onChange={this.props.handleChange} className="form-select mt-2">
												{weeksArray.map((item, index) => {
													if (item==52) {
														return (
															<React.Fragment key={item*7}>
																<option value={item*7} key={item}>{item} weeks</option>
																<option value="365" key="365">1 full year (365 days)</option>
															</React.Fragment>
														);
													}
													else if (item==78) {
														return (
															<React.Fragment key={item*7}>
																<option value={item*7} key={item}>{item} weeks</option>
																<option value="548" key="548">1.5 full years (548 days)</option>
															</React.Fragment>
														);
													}
													else {
														return <option value={item*7} key={item}>{item} weeks</option>
													}
												})}
											</select>
										</div>
									</div>
								</div>
							)}
						</div>
					</div>
				)}
				</div>
			</React.Fragment>
		)
	}
}